import { AuthService } from './../../../services/auth.service';
import { Equipe } from './../../../models/equipe.model';
import { HelpersService } from 'src/app/services/helpers.service';
import { Component, OnInit } from '@angular/core';
import { DatabaseService } from '../../../services/database.service';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-equipeslist',
  templateUrl: './equipeslist.component.html',
  styleUrls: ['./equipeslist.component.css']
})
export class EquipeslistComponent implements OnInit {

  private user: User;
  private equipes: Equipe[];
  liberarCriacaoEquipe = true;

  private novaEquipe: Equipe;
  nomeNovaEquipe: string;

  private hackathonId: string = this.helper.hackathonId;

  showSpinner = true;

  constructor(private helper: HelpersService,
              private database: DatabaseService,
              private auth: AuthService) {
    this.database.getEquipes(this.hackathonId)
    .then(rawData => rawData.subscribe((equipes: Equipe[]) => {
      this.equipes = equipes;
      this.auth.getUser.then(user => {
        this.user = user;
        this.liberarCriacaoEquipe = this.helper.hackathonLiberarCriacaoDeEquipes;
        this.verificarSeUserTemEquipe(equipes);
      });
    }));
  }

  ngOnInit(): void {
  }

  private verificarSeUserTemEquipe(equipes: Equipe[]): void {
    equipes.forEach(equipe => {
      const auxUserIndex = equipe.membros.findIndex(membro => membro.uid === this.user.user.uid);
      if (auxUserIndex !== -1) {
        this.helper.openSnackBar('Encontramos a sua equipe!', '');
        this.helper.setEquipeId(equipe.equipeId);
        this.helper.routeToResumoEquipe(equipe.nomeEquipe);
      }
    });
    this.showSpinner = false;
  }

  getEquipes(): Equipe[] {
    return this.equipes;
  }

  criarEquipe(): void {
    if (this.nomeNovaEquipe.length <= 0) {
      this.helper.openSnackBar('Digite um nome para a sua equipe', 'OK');
    } else {
      this.novaEquipe = this.newEquipe;
      this.novaEquipe.membros.push(this.user.user);
      this.database.setEquipe(this.novaEquipe);
      this.nomeNovaEquipe = '';
    }
  }

  private get newEquipe(): Equipe {
    return {
      desafioEscolhido: {
        titulo: '',
        descricao: ''
      },
      nomeEquipe: this.nomeNovaEquipe,
      membros: [],
      equipeId: '',
      hackathonId: this.helper.hackathonId,
      entregas: [],
      votosDesafio: [],
    };
  }

  entrarNaEquipe(equipe: Equipe): void {
    this.auth.getUser.then(user => {
      equipe.membros.push(user.user);
      this.helper.setEquipeId(equipe.equipeId);
      this.database.updateEquipe(equipe);
      this.helper.routeToResumoEquipe(equipe.equipeId);
    });
  }

}
